/* ============================================================
   Iron Landing — JS unificado para Shopify
   Incluye: selector de bundle, galería, FAQ, sticky bar,
   tracking (GA4/Meta) y COMPRAR AHORA -> checkout con Kaching.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.IRON_LANDING || {};

  /* ---------- 1. Selector de bundle (1 / 2 unidades) ---------- */
  (function bundleSelector() {
    var selector = document.querySelector('[data-bundle-selector]');
    if (!selector) return;
    var options = selector.querySelectorAll('.bundle-option');
    var priceNow = document.querySelector('[data-price-now]');
    var priceWas = document.querySelector('[data-price-was]');
    var priceDetail = document.querySelector('[data-price-detail]');
    var activeLabel = document.querySelector('[data-bundle-active-label]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var buyBtns = document.querySelectorAll('[data-cta="buy-now"]');

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('active'); });
        opt.classList.add('active');
        var price = opt.getAttribute('data-price');
        var was = opt.getAttribute('data-was');
        var detail = opt.getAttribute('data-detail');
        var label = opt.getAttribute('data-label');
        var bundle = opt.getAttribute('data-bundle');
        if (priceNow) priceNow.textContent = '$' + price;
        if (priceWas) priceWas.textContent = '$' + was;
        if (priceDetail) priceDetail.textContent = detail;
        if (activeLabel) activeLabel.textContent = label;
        if (stickyPrice) stickyPrice.textContent = '$' + price;
        buyBtns.forEach(function (b) { b.setAttribute('data-selected-bundle', bundle); });
      });
    });
  })();

  /* ---------- 2. Galería (thumbs + flechas) ---------- */
  (function gallery() {
    var thumbs = document.querySelector('[data-gallery-thumbs]');
    var mainImg = document.querySelector('[data-gallery-main]');
    var prevBtn = document.querySelector('[data-gallery-prev]');
    var nextBtn = document.querySelector('[data-gallery-next]');
    if (!thumbs || !mainImg) return;
    var buttons = Array.prototype.slice.call(thumbs.querySelectorAll('button'));
    var idx = 0;
    function setActive(i) {
      idx = (i + buttons.length) % buttons.length;
      buttons.forEach(function (b) { b.classList.remove('active'); });
      buttons[idx].classList.add('active');
      mainImg.src = buttons[idx].getAttribute('data-src');
    }
    buttons.forEach(function (btn, i) { btn.addEventListener('click', function () { setActive(i); }); });
    if (prevBtn) prevBtn.addEventListener('click', function () { setActive(idx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { setActive(idx + 1); });
  })();

  /* ---------- 3. FAQ acordeón ---------- */
  (function faq() {
    var faqEl = document.querySelector('[data-faq]');
    if (!faqEl) return;
    var items = faqEl.querySelectorAll('.faq-item');
    items.forEach(function (item) {
      var q = item.querySelector('.faq-question');
      var a = item.querySelector('.faq-answer');
      q.addEventListener('click', function () {
        var open = item.getAttribute('aria-expanded') === 'true';
        items.forEach(function (o) {
          o.setAttribute('aria-expanded', 'false');
          o.querySelector('.faq-answer').style.maxHeight = null;
        });
        if (!open) {
          item.setAttribute('aria-expanded', 'true');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  })();

  /* ---------- 4. Sticky bar inferior ---------- */
  (function stickyBar() {
    var bar = document.querySelector('[data-sticky-bar]');
    var hero = document.getElementById('hero');
    if (!bar || !hero) return;
    var threshold = hero.offsetTop + hero.offsetHeight;
    function toggle() {
      if (window.scrollY > threshold) bar.classList.add('visible');
      else bar.classList.remove('visible');
    }
    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
  })();

  /* ---------- 5. Tracking (dispara sobre gtag/fbq si ya existen) ---------- */
  function track(eventName, params) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', eventName, params || {});
      if (typeof window.fbq === 'function') {
        var map = { view_content: 'ViewContent', initiate_checkout: 'InitiateCheckout' };
        window.fbq('track', map[eventName] || eventName, params || {});
      }
    } catch (e) { /* nunca romper el flujo de compra por tracking */ }
  }

  document.addEventListener('DOMContentLoaded', function () {
    track('view_content', { content_name: 'Creatina Iron Nutrition 500g', value: 114000, currency: 'COP' });
  });

  /* ---------- 6. COMPRAR AHORA -> checkout (con Kaching) ---------- */
  function money(qty) { return qty === 2 ? 218000 : 114000; }

  function goCheckout() {
    var code = (CFG.discountCode || '').trim();
    // Con código: usa el link oficial de descuento de Shopify que lo aplica y redirige.
    // Sin código (Kaching automático): va directo al checkout.
    var url = code ? ('/discount/' + encodeURIComponent(code) + '?redirect=/checkout') : '/checkout';
    window.location.href = url;
  }

  function addAndCheckout(variantId, qty) {
    var body = JSON.stringify({ items: [{ id: variantId, quantity: qty }] });
    var addReq = function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body
      });
    };
    var chain = CFG.clearCartFirst
      ? fetch('/cart/clear.js', { method: 'POST' }).then(addReq)
      : addReq();
    chain.then(function (r) {
      if (!r.ok) throw new Error('add failed');
      goCheckout();
    }).catch(function () {
      // Fallback robusto: permalink de carrito con la cantidad
      window.location.href = '/cart/' + variantId + ':' + qty;
    });
  }

  document.querySelectorAll('[data-cta="buy-now"]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var qty = parseInt(btn.getAttribute('data-selected-bundle') || '1', 10);
      if (!qty || qty < 1) qty = 1;

      track('initiate_checkout', {
        content_name: 'Creatina Iron Nutrition 500g',
        quantity: qty, value: money(qty), currency: 'COP'
      });

      if (!CFG.variantId) {
        // Sin variante configurada: no romper, avisar en consola.
        console.warn('[Iron Landing] Falta window.IRON_LANDING.variantId (revisa el handle del producto en la sección).');
        return;
      }
      // Estado de carga en el botón
      if (!btn.dataset.loading) {
        btn.dataset.loading = '1';
        btn.style.opacity = '0.7';
        btn.style.pointerEvents = 'none';
      }
      addAndCheckout(CFG.variantId, qty);
    });
  });
})();
